import { Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';

interface ScrollableComponentProps {
  data: React.ReactNode[];
  scrollPercentageThreshold: number;
  scrollableInitialLimit: number;
}

export const ScrollableComponent: React.FC<ScrollableComponentProps> = ({
  data,
  scrollPercentageThreshold,
  scrollableInitialLimit,
}) => {
  const [listItemLimit, setListItemLimit] = useState(Math.min(scrollableInitialLimit, data.length));

  const handleScroll = useCallback(
    (event: Event) => {
      const eventTarget = event.target as HTMLElement;
      const verticalScrollPosition = eventTarget.scrollTop;
      const scrollHeight = eventTarget.scrollHeight;
      const scrollPercentage = (verticalScrollPosition / scrollHeight) * 100;
      if (scrollPercentage > scrollPercentageThreshold) {
        setListItemLimit((prevLimit) => Math.min(data.length, prevLimit + scrollableInitialLimit));
      }
    },
    [data.length, scrollPercentageThreshold, scrollableInitialLimit]
  );

  useEffect(() => {
    setListItemLimit(Math.min(scrollableInitialLimit, data.length));
  }, [data, scrollableInitialLimit]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [handleScroll]);

  const slicedChildren = data.slice(0, listItemLimit);

  return <Grid>{slicedChildren}</Grid>;
};
